import { render, staticRenderFns } from "./TelesalesDashboard.vue?vue&type=template&id=70bb9074&scoped=true"
import script from "./TelesalesDashboard.vue?vue&type=script&lang=js"
export * from "./TelesalesDashboard.vue?vue&type=script&lang=js"
import style0 from "./TelesalesDashboard.vue?vue&type=style&index=0&id=70bb9074&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bb9074",
  null
  
)

export default component.exports